(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  const setCollectionPromotionProductOrder = (scope = document) => {
    const grids = scope.querySelectorAll('.product-grid--collection-promotions');

    for (const grid of grids) {
      const promotions = [...grid.querySelectorAll(':scope > [data-collection-promotion-card]')];

      if (!promotions.length) continue;

      const getPositions = (attribute) =>
        promotions
          .map((promotion) => Number.parseInt(promotion.getAttribute(attribute), 10))
          .filter((position) => Number.isFinite(position) && position > 0)
          .sort((a, b) => a - b);

      const desktopPositions = getPositions('data-grid-position');
      const mobilePositions = getPositions('data-mobile-grid-position');

      const getFinalPosition = (basePosition, promotionPositions) => {
        let finalPosition = basePosition;

        for (let iteration = 0; iteration < promotionPositions.length; iteration++) {
          const promotionsBeforeProduct = promotionPositions.filter((position) => position <= finalPosition).length;
          const nextPosition = basePosition + promotionsBeforeProduct;

          if (nextPosition === finalPosition) break;

          finalPosition = nextPosition;
        }

        return finalPosition;
      };

      const products = [...grid.querySelectorAll(':scope > .product-grid__item:not([data-collection-promotion-card])')];

      for (const product of products) {
        const basePosition = Number.parseInt(product.getAttribute('data-collection-product-index'), 10);

        if (!Number.isFinite(basePosition) || basePosition < 1) continue;

        product.style.setProperty(
          '--collection-product-order-desktop',
          `${getFinalPosition(basePosition, desktopPositions) * 10}`
        );
        product.style.setProperty(
          '--collection-product-order-mobile',
          `${getFinalPosition(basePosition, mobilePositions) * 10}`
        );
      }
    }
  };

  const observeCollectionPromotionGridUpdates = (scope = document) => {
    const resultsLists = scope.querySelectorAll('results-list:not([data-collection-promotions-observed])');

    for (const resultsList of resultsLists) {
      resultsList.dataset.collectionPromotionsObserved = 'true';

      new MutationObserver(() => setCollectionPromotionProductOrder(resultsList)).observe(resultsList, {
        childList: true,
        subtree: true,
      });
    }
  };

  document.addEventListener('DOMContentLoaded', () => {
    setCollectionPromotionProductOrder();
    observeCollectionPromotionGridUpdates();
  });
  document.addEventListener('shopify:section:load', (event) => {
    setCollectionPromotionProductOrder(event.target);
    observeCollectionPromotionGridUpdates(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
